import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { URL_MATCHERS } from './share/entity/html-suffix-url-matcher';
import { siteLangGuard } from './share/guard/site-lang.guard';
import { sitePathLangGuard } from './share/guard/site-path-lang.guard';
import { sitePathGuard } from './share/guard/site-path.guard';


const domainRoutes: Routes = [
  { matcher: URL_MATCHERS.notfound, loadComponent: () => import('./not-found/not-found.component').then(mod => mod.NotFoundComponent) },
  { path: '', canActivate: [siteLangGuard], loadComponent: () => import('./web/web.component').then(m => m.WebComponent) },
  { matcher: URL_MATCHERS[':lang'], canActivate: [siteLangGuard], loadChildren: () => import('./web-generator/template-generator/template-generator.module').then(mod => mod.TemplateGeneratorModule) },
  { path: '**', loadComponent: () => import('./not-found/not-found.component').then(mod => mod.NotFoundComponent) },
];

const pathRoutes: Routes = [
  { matcher: URL_MATCHERS.notfound, loadComponent: () => import('./not-found/not-found.component').then(mod => mod.NotFoundComponent) },
  { path: '',  canActivate: [sitePathGuard], loadComponent: () => import('./web/web.component').then(m => m.WebComponent) },
  { matcher: URL_MATCHERS[':path'], canActivate: [sitePathGuard, sitePathLangGuard], loadComponent: () => import('./web/web.component').then(m => m.WebComponent) },
  { matcher: URL_MATCHERS[':path/:lang'], canActivate: [sitePathGuard, sitePathLangGuard], loadChildren: () => import('./web-generator/template-generator/template-generator.module').then(mod => mod.TemplateGeneratorModule) },
  { path: '**', loadComponent: () => import('./not-found/not-found.component').then(mod => mod.NotFoundComponent) },
];

@NgModule({
  imports: [RouterModule.forRoot(environment.mode === 'domain' ? domainRoutes : pathRoutes, { initialNavigation: 'enabledBlocking', enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
